import { alpha } from '@material-ui/core';
import { Box, Grid, Typography } from '@mui/material';

const PrescriptionSubGroup = (props) => {
    return (
        <Box
            sx={{
                p: 1.5,
                borderRadius: 2,
                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.03),
                border: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    display: 'block',
                    mb: 1,
                    color: 'text.secondary',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                }}
            >
                {props.title}
            </Typography>

            <Grid container spacing={3}>
                {props.children}
            </Grid>
        </Box>
    );
};

export default PrescriptionSubGroup;
